
/// <amd-module name="Search/Shared/Components/PivotCommands/Commands" />
import * as React from "react";
import { Button } from "VSSUI/Button";
import { IPivotCommandProps, IPivotCommands } from "./Commands.Props";
import { HeaderCommandBar } from "VSSUI/HeaderCommandBar";

export class PivotCommands extends React.Component<IPivotCommandProps, IPivotCommands> {
    constructor(props: IPivotCommandProps) {
        super(props);
        this.state = {
            farItems: [],
            items: []
        };
    }

    public render(): JSX.Element | null {
        const { items, farItems } = this.state;
        return (
            <div className="search-commandbar-container flex-row">
                {
                    items.length > 0 &&
                    <div className="commandbar-seperator flex-shrink"></div>
                }
                <div className="flex-row flex-grow commandbar search-commandbar-zoom">
                    {
                        <div className="near-items flex-grow">
                        {
                            items.map(nearItem => {
                                return <Button 
                                key={nearItem.id} 
                                {...nearItem} 
                                onClick={() => 
                                    {
                                        if (nearItem.onActivate) {                                                    
                                           nearItem.onActivate({id: nearItem.id, text: nearItem.text});
                                        }
                                    }
                                } />
                            })
                        }
                        </div>
                    }
                    <HeaderCommandBar items={farItems} className="far-items" />
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        this.props.pivotCommands.subscribe(this.onCommandsUpdated);
    }

    public componentWillUnmount(): void {
        this.props.pivotCommands.unsubscribe(this.onCommandsUpdated);
    }

    private onCommandsUpdated = (pivotCommands: IPivotCommands): void => {
        this.setState(pivotCommands);
    }
}
